import { ReactNode } from 'react'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'

import EdgeCollapseButton from './edge-collapse-button'
import { SIDEBAR_EXPANDED_WIDTH_PX } from './sidebar-layout'

type MaxChatPageProps = {
  isSidebarCollapsed: boolean
  onExpandSidebar: () => void
  sidebar: ReactNode
  chatArea: ReactNode
}

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: 0,
    display: 'grid',
    gridTemplateColumns: `${SIDEBAR_EXPANDED_WIDTH_PX}px minmax(0, 1fr)`,
    gap: 0,
    transition: 'all 300ms ease-out',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  rootCollapsed: {
    gridTemplateColumns: '0 minmax(0, 1fr)',
  },
  sidebarHost: {
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    transition: 'all 300ms ease-out',
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      inset: 0,
      zIndex: 4,
      transition: 'all 300ms ease-out',
    },
  },
  sidebarHostCollapsed: {
    opacity: 0,
    pointerEvents: 'none',
    transform: 'translateX(-16px)',
  },
  chatAreaHost: {
    minWidth: 0,
    minHeight: 0,
    height: '100%',
  },
}))

const MaxChatPage = ({ isSidebarCollapsed, onExpandSidebar, sidebar, chatArea }: MaxChatPageProps) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, { [classes.rootCollapsed]: isSidebarCollapsed })}>
      <EdgeCollapseButton visible={isSidebarCollapsed} onExpand={onExpandSidebar} />

      <div
        className={clsx(classes.sidebarHost, {
          [classes.sidebarHostCollapsed]: isSidebarCollapsed,
        })}
      >
        {sidebar}
      </div>

      <div className={classes.chatAreaHost}>{chatArea}</div>
    </div>
  )
}

export default MaxChatPage
